import React, { useState, createContext } from 'react';
import { useLockBodyScroll, useToggle } from 'react-use';
import http from '../utils/httpFacade';

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [session, setSession] = useToggle(true);

  useLockBodyScroll(!session);

  const register = async user => {
    try {
      return await http.post({ url: 'signup', body: JSON.stringify(user) });
    } catch (error) {
      return error;
    }
  };

  const login = async user => {
    try {
      return await http.post({ url: 'login', body: JSON.stringify(user) });
    } catch (error) {
      return error;
    }
  };

  const auth = (data, rememberMe) => {
    // eslint-disable-next-line valid-typeof
    if (typeof data !== 'undefined') {
      //TODO: make only the jwt stored in the localstorage
      // localStorage.setItem('cf-_jwt', JSON.stringify(data.token));
      // localStorage.setItem('cf-_profile', JSON.stringify(data.user));
      if (rememberMe) {
        sessionStorage.removeItem('jwt');
        localStorage.setItem('jwt', JSON.stringify(data));
      } else {
        localStorage.removeItem('jwt');
        sessionStorage.setItem('jwt', JSON.stringify(data));
      }
    }
  };

  const isAuthenticated = () => {
    let jwt = sessionStorage.getItem('jwt') || localStorage.getItem('jwt');
    if (jwt) {
      return JSON.parse(jwt);
    } else {
      return false;
    }
  };

  const logout = async (_id, next) => {
    try {
      await http.post({ url: 'logout', body: { _id } });
      sessionStorage.removeItem('jwt');
      localStorage.removeItem('jwt');
    } catch (error) {}
    next();
  };

  const verification = async (token, email) => {
    try {
      return await http.patch({
        url: `verification/${email}`,
        body: { token, access: 'validation' }
      });
    } catch (error) {
      return error;
    }
  };

  const forgotPassword = async email => {
    try {
      return await http.post({ url: 'password-setting', body: JSON.stringify(email) });
    } catch (error) {
      return error;
    }
  };

  const verifyToken = async query => {
    try {
      return await http.get({ url: 'password-setting', query });
    } catch (error) {
      return error;
    }
  };

  const updatePassword = async body => {
    try {
      return await http.patch({ url: 'password-setting', body: JSON.stringify(body) });
    } catch (error) {
      return error;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        login,
        logout,
        register,
        verification,
        auth,
        isAuthenticated,
        setSession,
        session,
        setUser,
        user,
        forgotPassword,
        verifyToken,
        updatePassword
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
